/* istanbul ignore file */
import { ProjectToolMessageCallback } from 'domain/projects/shared/projectToolsCreation';

const useCreateGitlabResponseHandler = () => {
  const handleAccountGroupStatus = (accountGroupStatus: any, callback: ProjectToolMessageCallback) => {
    if (accountGroupStatus.groupState !== 'ERROR') {
      callback({
        type: 'log',
        level: 'success',
        message: `Successfully ${accountGroupStatus.groupState} Gitlab Group for provided Account.`,
      });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to create or found Account Gitlab Group due to: ${accountGroupStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleProjectGroupCreationStatus = (projectGroupCreationStatus: any, callback: ProjectToolMessageCallback) => {
    if (projectGroupCreationStatus.isCreated) {
      callback({ type: 'log', level: 'success', message: `Successfully created Gitlab Project Group.` });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to create Gitlab Project Group due to: ${projectGroupCreationStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleDefaultRepoStatuses = (defaultRepoStatuses: any, callback: ProjectToolMessageCallback) => {
    let isPassed = true;

    defaultRepoStatuses.forEach((repoStatus: any) => {
      if (repoStatus.isCreated) {
        callback({
          type: 'log',
          level: 'success',
          message: `Successfully created Gitlab Project Repository ${repoStatus.projectName}.`,
        });
      } else {
        callback({
          type: 'log',
          level: 'error',
          message: `Failed to create Gitlab Project Repository ${repoStatus.projectName} due to: ${repoStatus.errors.join(' ')}.`,
        });
        isPassed = false;
      }
    });

    return isPassed;
  };

  const handleProjectUpdateLinksStatus = (projectUpdateStatus: any, callback: ProjectToolMessageCallback) => {
    if (projectUpdateStatus.isUpdated) {
      callback({
        type: 'log',
        level: 'success',
        message: `Successfully updated Project link to the Gitlab.`,
      });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to update Project link to the Gitlab due to ${projectUpdateStatus.errors.join(' ')}`,
      });
      return false;
    }
  };

  const handleGitlabResponse = (state: any, callback: ProjectToolMessageCallback) => {
    let isPassed = true;

    if (state.accountGroupCreationStatus) {
      isPassed = handleAccountGroupStatus(state.accountGroupCreationStatus, callback) && isPassed;
    }
    if (state.projectGroupCreationStatus) {
      isPassed = handleProjectGroupCreationStatus(state.projectGroupCreationStatus, callback) && isPassed;
    }
    if (state.defaultRepoStatuses) {
      isPassed = handleDefaultRepoStatuses(state.defaultRepoStatuses, callback) && isPassed;
    }
    if (state.projectFieldUpdatedStatus) {
      isPassed = handleProjectUpdateLinksStatus(state.projectFieldUpdatedStatus, callback) && isPassed;
    }

    callback({ type: 'status', status: isPassed ? 'passed' : 'failed' });
  };

  return {
    handleGitlabResponse,
  };
};

export default useCreateGitlabResponseHandler;
